import moment from 'moment';

export function buildRequestReportQuery({ startDate, endDate, propertyId, page, limit, typeExport }) {
  const toUTC = (date) => date
    ? moment(date, ['YYYY-MM-DD HH:mm:ss', moment.ISO_8601], true).utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
    : '';
  const params = new URLSearchParams({
    startDate: toUTC(startDate),
    endDate: toUTC(endDate),
    propertyId: propertyId || '',
  });
  if (typeExport) params.set('typeExport', typeExport);
  if (page) params.set('page', page);
  if (limit) params.set('limit', limit);
  return params.toString();
}
